export class TextFieldHelper {
    static iconButtonSuffixStyles = {
        root: {
            selectors: {
                ':hover': {
                    fontWeight: 'bolder',
                },
                ':active': {
                    fontWeight: 'bolder',
                },
                ':focus': {
                    fontWeight: 'bolder',
                },
            },
        },
    };

    static buttonSuffixStyles = {
        rootFocused: {
            backgroundColor: 'transparent',
        },
        rootHovered: {
            backgroundColor: 'transparent',
        },
        rootPressed: {
            backgroundColor: 'transparent',
        },
    };
}
